import type { zHomepageHeroSection } from '#app/types/schema.ts';
import { SectionDefaultProps } from '#app/types/type.ts';
import { z } from 'zod';
import SanityImage from './sanity-image';
import SanityLink from './sanity-link';
import { stegaClean } from '@sanity/client/stega';

type HomepageHeroProps = SectionDefaultProps & {
    data: z.infer<typeof zHomepageHeroSection>;
};

export default function HomepageHero({ data, encodeDataAttribute }: HomepageHeroProps) {
    const cleanData = stegaClean(data);
    const { heading, tagline, backgroundImage, foregroundImage, button } = cleanData;
	return (
		<div className="relative bg-white isolate overflow-hidden pt-14">
            <SanityImage
                image={backgroundImage}
                alt={backgroundImage.alt ?? ''}
                className="absolute inset-0 object-cover w-full h-full -z-10 pointer-events-none"
                loading='eager'
                aria-hidden="true"
            />
			<div className="mx-auto max-w-7xl px-6 lg:px-8 lg:pb-56">
				<div className="py-32 sm:py-48 lg:py-56">
					<div className='text-center'>
						{heading && (
                            <h1 className="text-balance text-5xl font-semibold tracking-tight text-black sm:text-7xl">
                                {heading}
                            </h1>
                        )}
						{tagline && (
                            <p className="mt-8 mx-auto max-w-2xl text-pretty text-lg font-medium text-black sm:text-xl/8">
                                {tagline}
                            </p>
                        )}
						<div className="mt-10 flex items-center justify-center gap-x-6">
							{button && (
                                <SanityLink link={button} />
                            )}
						</div>
					</div>
				</div>
			</div>
            <SanityImage
                image={foregroundImage}
                alt={foregroundImage?.alt ?? ''}
                className='w-full h-auto sm:-mt-[40%] pointer-events-none'
                loading='eager'
            />
		</div>
	)
}